import type { SOURCE_PLATFORM_TYPE } from '@/entities/public-filter/constants';

export enum ScrapingJobStatus {
  InProgress = 'IN_PROGRESS',
  Done = 'DONE',
}

interface BaseInternalScrapingJob {
  _id: string;
  documentCreatedAt: number; // unix timestamp
  ownerName: string;
  platform: SOURCE_PLATFORM_TYPE;
  status: ScrapingJobStatus;
  scrapedItemCount: number;
  endDate?: string; // YYYY-MM-DD
  temporalScheduleId?: string;
  memo?: string;
  scrapingType: 'onetime' | 'periodic';
}

// Google Search specific job
export interface GoogleSearchJob extends BaseInternalScrapingJob {
  type: 'GOOGLE_SEARCH';
  query: string;
  startDate: string; // YYYY-MM-DD
}

// Direct URL specific job
export interface DirectUrlJob extends BaseInternalScrapingJob {
  type: 'DIRECT_URL';
  postUrlCount: number; // Count of URLs that were actually scraped
  inputPostUrlCount: number; // Count of original URLs provided by the user
  shouldScrapeComments: boolean;
}

// Discriminated union type
export type InternalScrapingJob = GoogleSearchJob | DirectUrlJob;
